import React, { useRef } from 'react';
// Added UploadCloud and FilePlus to imports
import { ImageIcon, Loader, Download, UploadCloud, FilePlus, TrashIcon, ZoomIn, ZoomOut, RotateCw } from './Icons';

export default function EditorToolbar({
  showTools = false,
  projectName,
  scale,
  setScale,
  setRotation,
  onRotate,
  selectedPage,
  numPages,
  triggerImageUpload,
  isModifying,
  currentPreviewUrl,
  imageInputRef,
  handleImageSelected,
  onAppendUpload,
  showAddButtons,
  onInsertBlankPage,
  onDeletePage,
  onProfileClick
}) {
  // Ref for the new hidden PDF input
  const appendPdfInputRef = useRef(null);

  const handleZoomIn = () => setScale(prev => Math.min(prev + 0.1, 3));
  const handleZoomOut = () => setScale(prev => Math.max(prev - 0.1, 0.5));

  const triggerPdfUpload = () => {
    if (appendPdfInputRef.current) {
      appendPdfInputRef.current.click();
    }
  }

  const handleDownload = () => {
    if (currentPreviewUrl) {
      const link = document.createElement('a');
      link.href = currentPreviewUrl;
      const safeName = projectName ? `${projectName}.pdf` : 'document.pdf';
      link.download = safeName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const isDisabled = !showTools || isModifying;

  return (
    <div className="editor-toolbar-vertical">

      {/* --- USER PROFILE SECTION --- */}
      <div className="toolbar-header-align">
        <div className="user-menu-container">
          <div className="user-profile-small" title="User Menu">
            <span>JD</span>
          </div>

          {/* The Dropdown (Opens to the LEFT) */}
          <div className="user-dropdown-left">
            <div className="dropdown-item" onClick={onProfileClick}>
              My profile
            </div>
            <div className="dropdown-item" onClick={() => alert("Navigate to Billing")}>
              Billing
            </div>
            <div className="dropdown-divider"></div>
            <div
              className="dropdown-item text-danger"
              onClick={() => {
                if (window.confirm("Are you sure you want to sign out?")) {
                  console.log("Signing out...");
                }
              }}
            >
              Sign out
            </div>
          </div>
        </div>
      </div>

      {/* --- HIDDEN INPUTS --- */}
      <input
        type="file"
        accept="image/png, image/jpeg, image/jpg"
        ref={imageInputRef}
        style={{ display: 'none' }}
        onChange={handleImageSelected}
      />

      <input
        type="file"
        accept=".pdf"
        ref={appendPdfInputRef}
        style={{ display: 'none' }}
        onChange={(e) => {
          if (e.target.files && e.target.files[0]) {
            onAppendUpload(e.target.files[0]);
          }
          e.target.value = null;
        }}
      />

      {/* --- MAIN TOOLS --- */}
      <div className="v-toolbar-group main-tools">
        {/* 1. Add Image */}
        <button
          className="v-toolbar-btn"
          onClick={triggerImageUpload}
          disabled={isDisabled}
          title="Add Image Signature/Stamp"
        >
          {isModifying ? <Loader size={20} className="spin" /> : <ImageIcon size={20} />}
        </button>

        {/* 2. Add PDF */}
        <button
          className="v-toolbar-btn"
          onClick={triggerPdfUpload}
          disabled={isDisabled}
          title="Add Another PDF"
        >
          <UploadCloud size={20} />
        </button>

        {/* 3. Add Blank Page */}
        <button
          className="v-toolbar-btn"
          onClick={onInsertBlankPage}
          disabled={isDisabled}
          title="Add Blank Page"
        >
          <FilePlus size={20} />
        </button>

        <button
        className="v-toolbar-btn"
          onClick={onDeletePage}
          title="Delete Current Page"
          disabled={isDisabled} // Disable if no page is currently clicked/viewed
        >
          <TrashIcon size={20}/>
        </button>

        {/* 5. Rotate */}
        <button
          className="v-toolbar-btn"
          onClick={onRotate}
          title="Rotate Page 90°"
          disabled={isDisabled}
        >
          <RotateCw size={20} />
        </button>
      </div>

      <div className="v-separator"></div>

      {/* --- PAGE INFO --- */}
      <div className="v-toolbar-group page-info-group">
        <div className="page-info-display">
          <span className="page-num current" style={{ opacity: isDisabled ? 0.3 : 1 }}>{!isDisabled && selectedPage ? selectedPage : '-'}</span>
          <span className="page-divider">/</span>
          <span className="page-num total" style={{ opacity: isDisabled ? 0.3 : 1 }}>{!isDisabled && numPages ? numPages : '-'}</span>
        </div>
        <div className="page-info-label" style={{ opacity: isDisabled ? 0.3 : 1 }}>Page</div>
      </div>

      <div className="v-separator"></div>

      {/* --- ZOOM CONTROLS --- */}
      <div className="v-toolbar-group zoom-controls">
        <button className="v-toolbar-btn" onClick={handleZoomIn} title="Zoom In" disabled={isDisabled}>
          <ZoomIn size={20} />
        </button>
        <div className="zoom-display" style={{ opacity: isDisabled ? 0.3 : 1 }}>
          {isDisabled ? '--' : `${Math.round(scale * 100)}%`}
        </div>
        <button className="v-toolbar-btn" onClick={handleZoomOut} title="Zoom Out" disabled={isDisabled}>
          <ZoomOut size={20} />
        </button>
      </div>

      <div className="v-separator"></div>

      {/* --- DOWNLOAD --- */}
      <div className="v-toolbar-group">
        <button className="v-toolbar-btn download" onClick={handleDownload} title="Download PDF" disabled={isDisabled}>
          <Download size={20} />
        </button>
      </div>

    </div>
  );
}